"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  kr: "en",
  한국어: "영어",
  "받은 알림이 없습니다": "You do not have any notifications.",
  알림: "Notification",
  설정: "Setting",
  "모두 읽음": "Mark All As Read",
  "읽은 알림 삭제": "Delete Read Notifications",
  "모두 삭제": "Delete All",
  "변경했던 모든 세부 설정값을 초기 상태로 되돌립니다.\n초기화한 알림 설정은 저장 시 적용됩니다.": "Reset all settings to default.\nSave to apply reset on Notification Settings.",
  "알림 콘텐츠 설정": "Notification Contents Settings",
  초기화: "Reset",
  저장: "Save",
  "받은 알림이 없습니다.": "You have no received notifications.",
  "설정이 저장되었습니다.": "Your settings have been saved.",
  "설정 저장을 실패했습니다.": "Failed to save settings.",
  "x 알림 x": "In ",
  "알림 설정": "Notification Settings",
  "에서 받고 싶은 알림을 선택하세요.": ", select the notification you want to receive.",
  "안내": "Notice",
  "더보기": "See More",
  "<em onclick={{handleGoLogin}}>로그인</em>하시면<br />좋아하시는 BJ와 방송의<br />새로운 소식을 알려드립니다.": "If you <em onClick={{handleGoLogin}}>log in</em>,<br />you can receive updates from<br />your favorite streamers and channels."
};